export function readableFileSize(bytes: number, decimals = 2) {
  if (bytes === 0) return '0B';

  const kilobyte = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  const sizeIndex = Math.floor(Math.log(bytes) / Math.log(kilobyte));

  return parseFloat((bytes / Math.pow(kilobyte, sizeIndex)).toFixed(decimals)) + sizes[sizeIndex];
}
